var version = "3.39.0";

export { version };
